import React from 'react';

// components and helpers
import { Typography } from '@mui/material';
import { CssBaseline } from '@mui/material';
import Logo from '../../src/assets/img/logo.png';

// mui
import Grid from '@mui/material/Grid';

const MobileView: React.FC = () => {
    return (
        <div
            style={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <CssBaseline />
            <Grid container justifyContent="center">
                {/* Centered Image */}
                <Grid item xs={12}>
                    <img
                        src={Logo}
                        alt="Not available"
                        style={{
                            maxWidth: '50%',
                            marginBottom: '16px',
                            display: 'block',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    />
                </Grid>

                {/* Centered Text */}
                <Grid item xs={12}>
                    <Typography align="center">
                        This application is not available on mobile right now.
                        Please switch to a desktop to use HDE.
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
};

export default MobileView;
